export default __webpack_public_path__ + "b3099bface4b3276cabc06886e772cc5.svg";